<template>
  <div>
    <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        controls
        :indicators="false"
        background="#ababab"
        img-width="1024"
        img-height="480"
        style="text-shadow: 1px 1px 2px #333;"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
    >
      <!-- Text slides with image -->
      <b-carousel-slide
          text=""
          img-src="/assets/_birthday/cuz.png"
      />
      <b-carousel-slide
          text=""
          img-src="/assets/_birthday/wintermovie.png"
      />
    </b-carousel>
    <p v-if="false" class="mt-4">
      Slide #: {{ slide }}<br>
      Sliding: {{ sliding }}
    </p>
  </div>
</template>

<script>
export default {
  name:"Slide_Show",
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  },
  data() {
    return {
      slide: 0,
      sliding: null
    }
  }
}
</script>
